import * as types from "./lifeStone.constant";

const defaultState = { error:null,language:"en" , direction:"ltr",
    levelInfo:null , user:null , isFirstTime:false , levels:[]
    ,showForgetDialog:false, alternatives:[] , group:null , hasNewMessage:false,chatId:null , hasNewRequest:false,
    isConnected:3
};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.LIFE_STONE_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.LIFE_STONE_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
